<div class="slider" [class.dragging]="isDragging">
  @if (images().length > 1) {
    <div class="slider-navigation">
      <div class="nav-area nav-prev" (click)="previousSlide()">
        <span class="slider-icon-arrow" [innerHTML]="sliderArrowIcon | safe: 'html'"></span>
      </div>
      <div class="nav-area nav-next" (click)="nextSlide()">
        <span class="slider-icon-arrow" [innerHTML]="sliderArrowIcon | safe: 'html'"></span>
      </div>
    </div>
  }

  <div
    class="slider-container"
    [style.transform]="images().length > 1 ? 'translateX(-' + currentSlide * 100 + '%)' : 'none'"
  >
    @for (image of images(); track image) {
      <div class="slider-slide">
        @if (image.url) {
          <a class="slider-slide-link" [href]="image.url" [target]="linkTarget()" (click)="onPostClick($event)">
            <img [src]="image.imageUrl" class="slider-slide-image" />
          </a>
        } @else {
          <img [src]="image.imageUrl" class="slider-slide-image" />
        }
      </div>
    }
  </div>

  @if (images().length > 1) {
    <div class="slider-bottom">
      <div class="slider-dots">
        @for (image of images(); track image; let i = $index) {
          <div class="dot" [class.active]="currentSlide === i" (click)="goToSlide(i)"></div>
        }
      </div>
    </div>
  }
</div>
